import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "store";
import { trackPageView } from "utils/analytics";

const getPageTitle = (pathname: string): string => {
  const routes: Record<string, string> = {
    "/": "Sign In",
    "/home": "Home",
    "/messages": "Messages",
    "/settings": "Settings",
    "/profile": "Profile",
    "/playerSessions": "Player Sessions",
    "/hostpanel": "Host Panel",
    "/creategame": "Create Game",
    "/hostSessions": "Host Sessions",
    "/info": "About",
    "/contact": "Contact",
    "/terms": "Terms of Service",
    "/hostguide": "Host Guide",
    "/authactions": "Auth Actions",
    "/404": "Page Not Found",
  };

  // Handle dynamic routes
  if (pathname.startsWith("/conversation/")) {
    return "Conversation";
  }
  if (pathname.startsWith("/games/")) {
    return "Game Details";
  }
  if (pathname.startsWith("/profile/")) {
    return "User Profile";
  }
  if (pathname.startsWith("/editgame/")) {
    return "Edit Game";
  }
  if (pathname.startsWith("/manage/")) {
    return "Manage Game";
  }

  return routes[pathname] || "Unknown Page";
};

export const usePageTracking = () => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    trackPageView(location.pathname, pageTitle, user?.uid);
  }, [location.pathname, user?.uid]);
};
